const fileUpload = {
  bindings: {
    onSave: '&',
  },
  templateUrl: '/modules/packageManagement/file-management/upload/upload-module.html',
  controller: 'UploadController',
};

angular
    .module('package-management.module')
    .component('fileUpload', fileUpload);
  